<template>
  <div id="competition">
    <div v-if="active">
      <header-part v-if="!isStarted"></header-part>

      <question-part v-if="!hasFinished"></question-part>

      <div v-else class="finished">
        <h3>
          Правильных ответов: {{ results.correctAnswers }} из {{ results.totalQuestions }} &nbsp; ( за {{ results.itTookSeconds }} секунд )
        </h3>
        <div class="resume" v-html="results.text">
        </div>
        <div class="invite-wrapper">
          {{ inviteText }}
        </div>
        <div class="input-row">
          <label for="name-input">ФИО</label>
          <input type="text" v-model="memberName" @change="$v.memberName.$touch()" :class="{ invalid: $v.memberName.$invalid}" id="name-input">
          <div v-if="$v.memberName.$invalid" class="errors-list-wrapper">
            <ul class="errors-list">
              <li class="error-item" v-if="!$v.memberName.required" >Необходимо указать ФИО</li>
            </ul>
          </div>
        </div>
        <div class="input-row">
          <label for="specialization-input">Специальность</label>
          <input type="text" v-model="memberSpecialization" @change="$v.memberSpecialization.$touch()" :class="{ invalid: $v.memberSpecialization.$invalid}" id="specialization-input">
          <div v-if="$v.memberSpecialization.$invalid" class="errors-list-wrapper">
            <ul class="errors-list">
              <li class="error-item" v-if="!$v.memberSpecialization.required" >Укажите врачебную специализацию</li>
            </ul>
          </div>
        </div>
        <div class="input-row">
          <label for="email-input">Электронная почта</label>
          <input type="email" v-model="memberEmail" @change="$v.memberEmail.$touch()" :class="{ invalid: $v.memberEmail.$invalid }" id="email-input">
          <div v-if="$v.memberEmail.$invalid" class="errors-list-wrapper">
            <ul class="errors-list">
              <li class="error-item" v-if="!$v.memberEmail.required" >Необходимо указать Email</li>
              <li class="error-item" v-if="!$v.memberEmail.email" >Требуется корректный Email</li>
            </ul>
          </div>
        </div>
        <div style="position: relative">
          <button class="send-button control-btn left-index-wrapper" @click="sendResults">
            <span class="left-index"></span>
            Отправить
          </button>
          <button class="try-again-button control-btn" @click="startMe" title="Пройти еще раз">Пройти еще раз</button>
        </div>
      </div>

      <button @click="startMe" v-if="!isStarted" class="control-btn left-index-wrapper" id="startButton">
        <span class="left-index"></span>
         {{ startButtonText }}
      </button>
    </div>
    <div v-if="!active && !closeFinalText" class="final-text">
      <p>{{ finalText }}</p>
      <button class="control-btn" @click="closeFinalText = true">Закрыть</button>
    </div>
  </div>

</template>

<script>
// import Something from '.something'
import Header from './components/Header.vue'
import Question from './components/Question.vue'
import Fingerprint2 from 'fingerprintjs2'
import { required, email } from 'vuelidate/lib/validators'
import { fbase } from './main'
import { initialData } from './initData.js'

export default {
  data: function () {
    return {
      memberName: '',
      memberEmail: '',
      memberSpecialization: '',
      active: true,
      closeFinalText: false
    }
  },
  validations: {
    memberEmail: {
      required: required,
      email: email
    },
    memberName: {
      required: required
    },
    memberSpecialization: {
      required: required
    }
  },
  components: {
    headerPart: Header,
    questionPart: Question

  },
  methods: {
    startMe: function () {
      if (!this.$store.state.questions || !this.$store.state.finalText || !this.$store.state.resultMarks) {
        if (typeof quizzId === 'undefined') {
          alert('Не указан ИД опроса')
          return
        }

        var initDataDocId = quizzId
        var vm = this
        var db = fbase.firestore()
        db.settings({
          // timestampsInSnapshots: true
        })
        db.collection('initData').doc(initDataDocId).get()
          .then(function (doc) {
            if (doc.exists) {
              var initData = doc.data()
              vm.$store.commit('setInitialData', initData)
              vm.$store.commit('initStart')
              vm.$store.commit('nextQuestion')
              vm.$store.commit('timerReset')
              vm.$store.commit('timerStart')
            } else {
              alert('Запрошенный документ ' + initDataDocId + ' не найден. Продолжение невозможно')
            }
          })
          .catch(function (error) {
            alert('Не удалось получить исходные данные')
            console.log(error)
          })
      } else {
        this.$store.commit('initStart')
        this.$store.commit('nextQuestion')
        this.$store.commit('timerReset')
        this.$store.commit('timerStart')
      }
    },
    sendResults: function () {
      if (this.$v.$invalid) {
        alert('Пожалуйста, устраните все перечисленные ошибки и попробуйте снова. Требуется указать свое имя и корректный Email адрес ')
        return false
      } else {
        this.$store.commit('name', this.memberName)
        this.$store.commit('email', this.memberEmail)
        this.$store.commit('specialization', this.memberSpecialization)

        var vm = this
        fbase.auth().onAuthStateChanged(function (user) {
          if (user) {
            var db = fbase.firestore()
            db.settings({
              timestampsInSnapshots: true
            })
            var res = vm.$store.getters.results
            // var initData = vm.$store.getters.initData
            // db.collection('initData').add(initData)
            //   .then(function (docRef) {
            //     console.log(docRef)
            //   })
            //   .catch(function (error) {
            //     console.log(error)
            //   })
            // return
            db.collection('results/' + quizzId + '/' + res.email + '/browsers/' + res.userBrowserFingerprintHash)
              .add(res)
              .then(function (docRef) {
                var cUser = fbase.auth().currentUser
                if (cUser && cUser.isAnonymous) {
                  cUser.delete()
                    .then(function () {
                      //    user deleted
                    })
                    .catch(function (error) {
                      console.log(error)
                      console.log('anonymous user was not deleted')
                    })
                }
                vm.active = false
              })
              .catch(function (error) {
                alert('Что то пошло не так во время сохранения данных')
                console.log(error)
              })
          } else {
            // не залогинен
          }
        })

        fbase.auth().signInAnonymously()
          .then(function (response) {
            // console.log( response );
          })
          .catch(function (error) {
            alert('Что-то пошло не так при попытке доступа к БД')
            console.log(error)
          })
      }
    }
  },
  watch: {
    // qNumber : function(newValue, oldValue) {
    // },
  },
  computed: {
    isStarted: function () {
      return this.$store.getters.currentQuestion !== false
    },
    qNumber: function () {
      return this.$store.getters.currentQuestion
    },
    hasFinished: function () {
      return this.$store.getters.isFinished
    },
    results: function () {
      var r = this.$store.getters.results
      var cA = r.correctAnswersAmount
      var objToReturn = {
        totalQuestions: r.totalQuestionsAmount,
        correctAnswers: cA,
        text: this.$store.getters.resultMark(cA),
        itTookSeconds: this.$store.state.timerValue
      }
      return objToReturn
    },
    timerValue: function () {
      return this.$store.state.timerValue
    },
    finalText: function () {
      return this.$store.getters.finalText
    },
    inviteText: function () {
      return this.$store.getters.inviteText
    },
    startButtonText: function() {
      return this.$store.state.startButtonText
    },
  },
  mounted: function () {
    var me = this
    new Fingerprint2().get(function (result, components) {
      me.$store.commit('setFingerprintHash', result)
      me.$store.commit('setFingerprintObj', components)
    }, me)

    if (typeof quizzId === 'undefined') {
      alert('Не указан ИД опроса')
      return
    }

    var initDataDocId = quizzId;
    var vm = this
    // vm.$store.commit('setInitialData', initialData)
    var db = fbase.firestore()
    db.settings({
      timestampsInSnapshots: true
    })
    db.collection('initData').doc(initDataDocId).get()
      .then(function (doc) {
        if (doc.exists) {
          var initData = doc.data()
          vm.$store.commit('setInitialData', initData)
        } else {
          alert('Запрошенный документ ' + initDataDocId + ' не найден. Продолжение невозможно')
        }
      })
      .catch(function (error) {
        alert('Не удалось получить исходные данные')
        console.log(error)
        console.log(error)
      })
  }
}
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Comfortaa|Jura|Oswald');

  #competition {
    font-family: 'Comfortaa', 'Jura','Oswald', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin: 15px auto;
    width: 100%;
    max-width: 800px;
    padding: 10px 20px;
    background: rgba(0,0,0,0.02);
    outline: 1px solid rgba(0,0,0,0.15);
    font-size: 18px!important;
    color: #4e4d4d;
    box-sizing: border-box;
    .init-img-wrapper {
      img {
        /*width: auto;*/
        width: 400px;
        max-width: 100%!important;
      }
    }
    .left-index-wrapper {
      padding-left: 25px!important;
      position: relative;
      span.left-index {
        display: inline-block;
        width: 25px;
        height: 100%;
        left: 0px;
        top: 0px;
        font-size: 1.1em;
        position: absolute;
        /*background: #4197e6;*/
        background: #40ae49;
        font-weight: 700;
        padding-top: 5px;
        color: white;
      }
    }
    .control-btn {
      border: none;
      outline: none;
      padding: 10px 15px;
      color: #232323;
      font-size: 1.2em;
      cursor: pointer;
      background: #c9cac9;
      transition: background 0.5s ease;
      box-shadow: 1px 1px 5px rgba(70,0,0,0.6);
      &.left-index-wrapper {
        padding-left: 30px!important;
      }
      &:active, &:focus {
        border: none;
        outline: none;
      }
      &:hover {
        background: darken(#c9cac9, 10%);
      }
    }

    .fade-enter {
      opacity: 0;
    }
    .fade-enter-active {
      transition: opacity 2s ease;
    }
    .fade-leave {

    }
    .fade-leave-active {
      transition: opacity 0.5s ease;
      opacity: 0;
    }
    div,p,ul,li,span {
      box-sizing: border-box;
    }
    img {
      width: 100%;
      max-width: 450px!important;
    }
    ul {
      list-style: none;
      padding: 0px;
      margin: 0px;
    }
    h2 {
      font-size: 1.2em;
      line-height: 28px;
      font-weight: normal;
      padding: 15px;
      width: 100%;
      box-sizing: border-box;
      text-align: left;
    }
    h2#osp-quizz-start-text {
        padding: 0px;
        margin-top: 0px;
    }
    .question-wrapper {
      font-size: 1em;
      .question {
        /*border-bottom: 3px solid #cd0400;*/
        border-bottom: 3px solid #40ae49;
        padding-bottom: 15px;
        .q-title {
          font-size: 1.2em;
            font-family: sans-serif;
            font-weight: normal;
          line-height: 28px;
          text-align: center;
          /*box-shadow: 0px 1px 3px rgba(0,0,0,0.2);*/
          padding: 5px;
          margin: 1em 0;
            text-align: left;
            color: #40ae49;
          > ol {
            /*list-style: disc;*/
            /*list-style-position: inside;*/
            text-align: left;
              font-size: 0.8em;
              line-height: 21px;
              color:#4e4d4d;
              margin-top: 8px;
            li {
                margin-bottom: 8px;
            }
          }
        }
        .q-info {
          margin: 5px 0px;
          text-align: center;
          color: #cd0400;
          font-size: 0.8em;
          font-weight: 600;
          /*border-bottom: 3px solid #cd0400;*/
          padding-bottom: 5px;
          text-align: left;
        }
        .images-list {
          li {
            display: inline-block;
            cursor: default;
            vertical-align: top;
            margin: 0px 2px;
            padding: 3px;
            background: rgba(0,0,0,0.1);
            max-width: 20%;
            overflow: hidden;
            margin-right: 25px;
            margin-bottom: 15px;
            box-sizing: border-box;
            .image-caption {
              display: block;
              font-size: 0.7em;
            }
            img {
              display: inline-block;
              width: 100%;
            }
          }
        }
        .audios-list {
          background: rgba(0,0,0,0.1);
          padding: 10px 0px;
          li {
            display: inline-block;
            width: 280px;
            margin-bottom: 10px;
            margin-right: 5px;
          }
        }
        .single-image {
          img {
            width: auto;
            max-height: 350px;
          }
        }
      }
      .variants-wrapper {
        .q-text {
          font-size: 1.1em;
          margin: 1em 0;
        }
        .variants {
          /*border: 1px solid rgba(0,0,0,0.1);*/
          padding: 15px;
          /*background: rgba(0,0,0,0.03);*/
          display: flex;
          flex-direction: row;
          justify-content: center;
          flex-wrap: wrap;
          .variant-item {
            flex-basis: 45%;
            /*flex: 1;*/
            cursor: pointer;
            /*display: inline-block;*/
            margin: 10px 5px;
            width: 45%;
            background: rgba(0,0,0,0.1);
            padding: 5px;
            color: #333;
            font-weight: bolder;
            /*vertical-align: top;*/
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 40px;
            transition: all 0.5s ease;
              font-family: sans-serif;
              font-size: 19px;
              font-weight: normal;
            .variant-desc {
              font-size: 12px;
              display: block;
            }
            &.selected {
              background: rgba(0,0,0,0.2);
            }
            &.correct {
              /*box-shadow: 0px 0px 5px 2px rgba(0,255,0,0.8);*/
              color: green;
            }
            &.incorrect {
              /*box-shadow: 0px 0px 5px rgba(255,0,0,0.8);*/
            }
            &:hover {
              background: rgba(0, 0, 0, 0.2);
              box-shadow: 0px 0px 10px rgba(0,0,0,0.6);
            }
          }
        }
      }
      .after-answered-text-wrapper {
        font-size: 1.0em;
          text-align: left;
          font-family: sans-serif;
          font-weight: normal;
        padding: 10px;
        /*background: rgba(0,0,0,0.04);*/
        margin-bottom: 15px;
        margin-top: 15px;
        /*font-weight: bold;*/
        &.correct {
          color: #4e4d4d;
        }
        &.incorrect {
          color: #cd0400;
        }
        p {
          margin: 0px;
        }
      }
      .controls-wrapper {
        padding-bottom: 15px;
      }
    }
    .finished {
      padding-bottom: 20px;
      h3 {
        padding: 20px 10px;
        font-weight: 700;
        /*text-decoration: underline;*/
        /*font-size: 1em;*/
        margin: 0px;

        color: #cd0400;
        text-align: left;
        font-size: 0.8em;
      }
      .resume {
        font-size: 1.4em;
        font-weight: bold;
        /*color: #4197e6;*/
        padding: 15px;
        /*background: rgba(0,0,0,0.05);*/
      }
      .invite-wrapper {
        padding: 15px;
        font-size: 1.2em;
      }
      .input-row {
        margin-bottom: 10px;
        label {
          display: block;
          color: black;
          font-size: 1em;
          font-weight: bolder;
        }
        input {
          outline: none;
          border: none;
          margin-top: 5px;
          border: 1px dashed rgba(0,0,0,0.2);
          height: 30px;
          padding: 0px 10px;
          font-weight: bold;
          font-size: 1.1em;
          color: #4e4e4e;
          &:focus, &:active {
            box-shadow: 0px 0px 8px rgba(0,0,255,0.4);
          }
          &.invalid {
            box-shadow: inset 0px 0px 3px rgba(255,0,0,0.4);
          }
        }
        .errors-list-wrapper {
          font-size: 0.8em;
          color: red;
          .errors-list {
            .error-item {

            }
          }
        }
      }
      .send-button, .try-again-button {
        font-size: 1.3em;
        padding: 5px 10px;
        display: inline-block;
        vertical-align: top;
        /*margin-right: 10px;*/
        &:focus, &:Active {
          outline: none;

        }
      }
      .try-again-button {
        /*background: url("https://admin.opensystems.ru/data/doc/dgl-blade-competition/play-again-icon.png") no-repeat center;*/
        background: none;
        /*background-size: 30px;*/
        width: 160px;
        font-size: 18px;
        color:#40ae49;
        height: 37px;
        box-shadow: none;
        border: none;
        outline: none;
        position: absolute;
        top: 0px;
        right: 0px;
        /*border-radius: 8px;*/
        &:hover {
          outline: 1px dashed rgba(0,0,0,0.2);
        }
      }
    }
    .final-text {
      p {
        font-size: 1.4em;
        font-weight: bolder;
      }
    }
  }
  /* On screens that are 600px or less, set the background color to olive */
  @media only screen and (min-width: 320px) and (max-width: 666px) {
    #competition {
      .question-wrapper {
        .question {
          .images-list {
            li {
              max-width: 100%;
            }
          }
          .single-image {
            img {
              width: 100%;
              height: auto;
            }
          }

        }
        .variants-wrapper {
          .variants {
            .variant-item {
              flex-basis: 100%;
            }
          }
        }
      }

    }
  }
</style>
